<template>

    <layout-default>
        <router-view />
    </layout-default>

</template>

<script>
import LayoutDefault from './layouts/LayoutDefault.vue';
export default {
	components: { LayoutDefault },
    name: "App",
    data() {
        return {
            layout: "div",
        }
    }
};
</script>
